import React, { useEffect, useState } from "react";
import "./BusinessHours.css";

const BusinessHours = ({ business, saving, onSave }) => {
  const [formData, setFormData] = useState({
    openingTime: "",
    closingTime: "",
    weeklyHoliday: "",
    businessStatus: "Open",
  });

  useEffect(() => {
    if (business) {
      setFormData({
        openingTime: business.business?.openingTime || "",
        closingTime: business.business?.closingTime || "",
        weeklyHoliday: business.business?.weeklyHoliday || "",
        businessStatus: business.businessStatus || "Open",
      });
    }
  }, [business]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <div className="hours-card">

      <div className="card-header">

        <div>
          <h3>🕒 Business Hours</h3>
          <p>
            Set your operating hours and availability.
          </p>
        </div>

        <span
          className={`status-badge ${formData.businessStatus.toLowerCase()}`}
        >
          {formData.businessStatus}
        </span>

      </div>

      <form onSubmit={handleSubmit}>

        <div className="hours-grid">

          <div className="form-group">
            <label>Opening Time</label>

            <input
              type="time"
              name="openingTime"
              value={formData.openingTime}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Closing Time</label>

            <input
              type="time"
              name="closingTime"
              value={formData.closingTime}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Weekly Holiday</label>

            <select
              name="weeklyHoliday"
              value={formData.weeklyHoliday}
              onChange={handleChange}
            >
              <option value="">Select Holiday</option>
              <option value="None">No Holiday</option>
              <option value="Sunday">Sunday</option>
              <option value="Monday">Monday</option>
              <option value="Tuesday">Tuesday</option>
              <option value="Wednesday">Wednesday</option>
              <option value="Thursday">Thursday</option>
              <option value="Friday">Friday</option>
              <option value="Saturday">Saturday</option>
            </select>
          </div>

          <div className="form-group">
            <label>Business Status</label>

            <select
              name="businessStatus"
              value={formData.businessStatus}
              onChange={handleChange}
            >
              <option value="Open">🟢 Open</option>
              <option value="Busy">🟡 Busy</option>
              <option value="Closed">🔴 Closed</option>
            </select>
          </div>

        </div>

        <div className="hours-footer">

          <div className="hours-info">
            💡 Customers can see your business status and working hours in real time.
          </div>

          <button
            className="hours-btn"
            type="submit"
            disabled={saving}
          >
            {saving ? "Saving..." : "Save Business Hours"}
          </button>

        </div>

      </form>

    </div>
  );
};

export default BusinessHours;